import { useState, useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios/index";
import DateFunc from '@/lib/lyg/date_func';
import strFunc from '@/lib/lyg/string';
import LayerPopup from '@/pcomponents/common/popup/layer/layer_popup';
import TextBookManageWordPopup from "@/pages/comp/plan/word/word_inside/popup/manage_word";
import WordInsideWritePopup from "@/pages/comp/plan/word/word_inside/popup/write";
import WordInsideUseStuLisePopup from "@/pages/comp/plan/word/word_inside/popup/use_stu_list";
import getXcolumnJson from "./xcolumn/list";
import Paging from "@/pcomponents/common/crud/list/paging/paging";
import ListComponent from '@/pcomponents/common/crud/list/list/list_component';
import CoolenMoveUrl from "@/pcomponents/common/content/coolen/study/func/move_url";
import UploadWordArea from "../upload_word";
import SearchArea from "./area/search";
import ManageArea from "./area/manage";
import { title } from 'process';

function WordInsideListArea(props: any) {
  let myProps = {
    ...props
  };
  let user = useSelector((state: any) => state.user);
  const ListComponentRef = useRef<any>(null);
  const xColumnArr = getXcolumnJson();
  let now_date_str = DateFunc.get_date_format(new Date(), "Y-m-d");
  const [listOpt, setListOpt] = useState({
    ...xColumnArr.list_opt,
    s_title_like: "",
    s_word_type: "",
    order_id: "a_title",
    s_addon_study_word: "1",
    s_addon_use: "1",
  });
  const [infoArr, setInfoArr] = useState<any>([]);

  const [countInfo, setCountInfo] = useState({ "tot": 0 });
  const default_popup_data = {
    isOpen: false,
    sort: "manage_word",//manage_word,write,use_stu_list
    title: "팝업",
    listOpt: {},
    g_par_id: "",
    g_par_seq: "",
    row_data: {},
    is_update: false,
    inside_seq: "",
    width: "100%",
    height: "90%",
  };
  const [popupData, setPopupData] = useState({ ...default_popup_data });

  useEffect(() => {
    list({});
  }, [user.comp_seq]);

  const list = (inOptObj: any) => {
    let tmp_listOpt: any = {
      ...listOpt,
      ...inOptObj
    };
    setListOpt(tmp_listOpt);
    tmp_listOpt.s_mcomp_seq = user.comp_seq;
    if (strFunc.is_empty(tmp_listOpt.s_mcomp_seq)) {
      return false;
    }

    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/plan/word/word_inside/list', tmp_listOpt, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          setInfoArr(response.data["data"]["info_arr"]);
          setCountInfo(response.data["data"]["count_info"]);
          if (ListComponentRef.current) {
            ListComponentRef.current.setInfoArr(response.data["data"]["info_arr"]);
          }
        } else {

        }
      });
  };

  const get_select_data_arr = () => {
    let select_data_arr: any = [];
    if (ListComponentRef.current) {
      select_data_arr = ListComponentRef.current.getSelectedRows();
    }
    return select_data_arr;
  };

  const delete_by_ajax = (inData: any) => {
    let opt_obj = {
      select_info_arr: get_select_data_arr(),
      ...inData
    };
    if (opt_obj.select_info_arr.length == 0) {
      alert("선택이 없습니다.");
      return false;
    }

    if (!window.confirm("선택한 단어장을 삭제하시겠습니까?")) {
      return false;
    }

    let form_json_data = {
      data_arr: opt_obj.select_info_arr,
    };

    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/plan/word/word_inside/delete', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          list({});
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  const open_manage_word_popup = (inData: any) => {
    let opt_obj = {
      g_par_id: "word_inside",
      g_par_seq: "",
      ...inData
    };

    if (strFunc.is_empty(opt_obj.g_par_id)) {
      alert("분류가 선택되지 않았습니다.");
      return false;
    }
    if (strFunc.is_empty(opt_obj.g_par_seq)) {
      alert("분류키가 선택되지 않았습니다.");
      return false;
    }

    setPopupData({
      ...default_popup_data,
      isOpen: true,
      sort: "manage_word",
      g_par_id: opt_obj.g_par_id,
      g_par_seq: opt_obj.g_par_seq,
      title: "단어 관리",
      width: "80%",
    });
  };

  const open_write_popup = (inData: any) => {
    let opt_obj = {
      select_info_arr: get_select_data_arr(),
      ...inData
    };
    if (opt_obj.select_info_arr.length == 0) {
      alert("선택된 단어장이 없습니다.");
      return false;
    }
    if (opt_obj.select_info_arr.length >= 2) {
      alert("한개만 선택해 주세요.");
      return false;
    }
    let row_data = opt_obj.select_info_arr[0];

    setPopupData({
      ...default_popup_data,
      isOpen: true,
      sort: "write",
      title:"수정",
      row_data: row_data,
      is_update: true,
    });
  };

  const open_use_stu_list_popup = (inData: any) => {
    let opt_obj = {
      inside_seq: "",
      ...inData
    };
    if (strFunc.is_empty(opt_obj.inside_seq)) {
      alert("선택된 단어장이 없습니다.");
      return false;
    }

    setPopupData({
      ...default_popup_data,
      isOpen: true,
      sort: "use_stu_list",
      title:"사용 학생 목록",
      inside_seq: opt_obj.inside_seq,
      is_update: true,
    });
  };

  const customCellRenderer = (params: any) => {
    /*
      {
        "rowData":rowData,
        "idx":idx,
        "key":key,
        "value":row_val,
        "origin_val":origin_val,
      }
    */
    let val_str = params.value;
    if (params.key == "row_view_word_count") {
      if (params.rowData["cg_word_arr"]) {
        val_str = strFunc.comma(params.rowData["cg_word_arr"].length);
      }
      val_str = (
        <div className='text-center'>
          {val_str}개
          <button
            className='btn btn-gray ml-1'
            onClick={() => {
              open_manage_word_popup({
                g_par_seq: params.rowData["a_seq"]
              });
            }} >학습수정</button>
        </div>
      );
    } else if (params.key == "row_view_user") {
      if (params.rowData["use_arr"]) {
        val_str = strFunc.comma(params.rowData["use_arr"].length) + "명";
      } else {
        val_str = "0명";
      }

      val_str = (
        <div className='text-center'>
          {val_str}
          <button className='btn btn-dark ml-1'
            onClick={() => {
              open_use_stu_list_popup({ inside_seq: params.rowData["a_seq"] });
            }}
          >보기</button>
        </div>
      );

    } else if (params.key == "row_view_preview") {
      let row_title_str=params.rowData["a_title"];
      let cool_move_opt: any = {
        coolen_study_par_id: "word_inside",
        coolen_study_par_seq: params.rowData["a_seq"],
        coolen_study_sort: "word_school",
        study_is_save: "",
        is_new_window: "1",
        back_sort: "popup",
        title:row_title_str,
      };
      if (params.rowData["a_word_type"] == "stc") {
        cool_move_opt.coolen_study_sort = "word_school2";
      }
      val_str = (
        <div className='text-center'>
          {params.rowData.cg_word_arr.length > 0 &&
            <button className='btn btn-dark'
              onClick={() => {
                CoolenMoveUrl.go_to_url(cool_move_opt);
              }} >미리보기</button>
          }
        </div>
      );
    }
    return val_str;
  };

  return (
    <div>
      <div>
        <UploadWordArea
          list={list}
        ></UploadWordArea>
      </div>
      <div>
        <SearchArea
          list={list}
          listOpt={listOpt}
          setListOpt={setListOpt}
        ></SearchArea>
      </div>
      <div className='mt-1'>
        <ManageArea
          delete_by_ajax={delete_by_ajax}
          open_write_popup={open_write_popup}
        ></ManageArea>
      </div>
      <div className='mt-1'>
        <ListComponent
          ref={ListComponentRef}
          infoArr={infoArr}
          xColumnArr={xColumnArr}
          gridOpt={{
            is_add_idx_num: true,
            is_add_checkbox: true,
            td_align: "center",
            customCellRenderer: customCellRenderer
          }}
        ></ListComponent>
      </div>
      <Paging now_page={listOpt.now_page}
        num_per_page={listOpt.num_per_page}
        total_rec={countInfo.tot}
        is_view_num_per_page={true}
        onChangePage={(now_page: number) => { list({ now_page: now_page }); }}
        onChangeNumPerPage={(num_per_page: number) => { list({ now_page: 1, num_per_page: num_per_page }); }}></Paging>

      {popupData.isOpen &&
        <LayerPopup closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }} title={popupData.title}
          width={popupData.width} height={popupData.height} >
          {popupData.sort === "manage_word" &&
            <TextBookManageWordPopup
              g_par_id={popupData.g_par_id}
              g_par_seq={popupData.g_par_seq}
              callbackData={(inData: any) => { }}
              refreshData={(inData: any) => { list({}); }}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}></TextBookManageWordPopup>
          }
          {popupData.sort === "write" &&
            <WordInsideWritePopup
              row_data={popupData.row_data}
              is_update={popupData.is_update}
              callbackData={(inData: any) => { }}
              refreshData={(inData: any) => { list({}); }}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
            ></WordInsideWritePopup>
          }
          {popupData.sort === "use_stu_list" &&
            <WordInsideUseStuLisePopup
              inside_seq={popupData.inside_seq}
              callbackData={(inData: any) => { }}
              refreshData={(inData: any) => { list({}); }}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
            ></WordInsideUseStuLisePopup>
          }
        </LayerPopup>
      }
    </div>
  );
};
export default WordInsideListArea;